module.exports = __webpack_public_path__ + "img/Toppone_DX.563f7611.png";